<template>
  <div class="ai-section">
    <div class="section-title">
      Questions Performance
    </div>

    <div class="question-count-grid">
      <div class="question-count-card">
        <span>Answered</span>
        <strong>{{ formatNumber(questions.answered) }}</strong>
      </div>

      <div class="question-count-card">
        <span>Signed off</span>
        <strong>{{ formatNumber(questions.completed) }}</strong>
      </div>

      <div class="question-count-card">
        <span>Correctly answered</span>
        <strong>{{ formatNumber(questions.correctlyAnswered) }}</strong>
      </div>
    </div>

    <div class="small-stat-row">
      <span>Signed off vs answered</span>
      <strong>{{ questions.completedRate }}%</strong>
    </div>

    <div class="score-bar">
      <div
          class="score-fill warning"
          :style="{ width: questions.completedRate + '%' }"
      ></div>
    </div>

    <div class="small-stat-row margin-top">
      <span>Accuracy rate</span>
      <strong>{{ questions.accuracyRate }}%</strong>
    </div>

    <div class="score-bar">
      <div
          class="score-fill good"
          :style="{ width: questions.accuracyRate + '%' }"
      ></div>
    </div>

    <div class="note-box">
      {{ questions.insight }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionsPerformanceBlock',

  props: {
    questions: Object,
    formatNumber: Function
  }
};
</script>

<style scoped>
.ai-section {
  border-top: 1px solid #e1e1e1;
  padding-top: 14px;
  margin-bottom: 22px;
}

.section-title {
  margin-bottom: 12px;
  color: #111;
  font-size: 14px;
  font-weight: 900;
}

.question-count-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-bottom: 14px;
}

.question-count-card {
  border: 1px solid #e1e1e1;
  background: #f4f9fc;
  padding: 10px;
  border-radius: 4px;
}

.question-count-card span {
  display: block;
  color: #666;
  font-size: 11px;
  margin-bottom: 2px;
}

.question-count-card strong {
  color: #111;
  font-size: 18px;
  font-weight: 900;
}

.small-stat-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #333;
  font-size: 12px;
  margin-bottom: 6px;
}

.small-stat-row strong {
  color: #111;
}

.margin-top {
  margin-top: 14px;
}

.score-bar {
  background: #eceff1;
  overflow: hidden;
  height: 7px;
}

.score-fill {
  height: 7px;
}

.good {
  background: #39aa94;
}

.warning {
  background: #f0ad4e;
}

.note-box {
  margin-top: 14px;
  padding: 10px;
  background: #f4f9fc;
  border-left: 4px solid #39aa94;
  color: #333;
  font-size: 12px;
  line-height: 1.45;
}
</style>
